import React, { useState } from 'react';
import './Quiz.css';

const Quiz = ({ quizSet, onQuizComplete, onBackToHome }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [score, setScore] = useState(0);
  const [answeredQuestions, setAnsweredQuestions] = useState([]);

  const questions = quizSet.questions;

  const handleAnswerClick = (answerIndex) => {
    if (selectedAnswer !== null) return; // 既に回答済みの場合は何もしない

    setSelectedAnswer(answerIndex);
    setShowExplanation(true);

    const isCorrect = answerIndex === questions[currentQuestion].correctAnswer;

    // スコアを更新
    const newScore = isCorrect ? score + 1 : score;
    setScore(newScore);

    // 回答履歴を保存
    setAnsweredQuestions([
      ...answeredQuestions,
      {
        questionId: questions[currentQuestion].id,
        isCorrect,
        selectedAnswer: answerIndex
      }
    ]);
  };

  const handleNextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedAnswer(null);
      setShowExplanation(false);
    } else {
      // クイズ終了 - answeredQuestionsから正解数を計算
      // 最後の問題の結果を含める
      const isLastCorrect = selectedAnswer === questions[currentQuestion].correctAnswer;
      const allAnswers = [
        ...answeredQuestions,
        {
          questionId: questions[currentQuestion].id,
          isCorrect: isLastCorrect,
          selectedAnswer: selectedAnswer
        }
      ];
      const finalScore = allAnswers.filter(a => a.isCorrect).length;
      onQuizComplete(finalScore);
    }
  };

  const question = questions[currentQuestion];

  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <div className="set-title-small">{quizSet.title}</div>
        <div className="question-counter">
          問題 {currentQuestion + 1} / {questions.length}
        </div>
      </div>

      <div className="question-section">
        <h2 className="question-text">{question.question}</h2>
      </div>

      <div className="options-section">
        {question.options.map((option, index) => {
          let buttonClass = 'option-button';

          if (selectedAnswer !== null) {
            if (index === question.correctAnswer) {
              buttonClass += ' correct';
            } else if (index === selectedAnswer && selectedAnswer !== question.correctAnswer) {
              buttonClass += ' incorrect';
            } else {
              buttonClass += ' disabled';
            }
          }

          return (
            <button
              key={index}
              className={buttonClass}
              onClick={() => handleAnswerClick(index)}
              disabled={selectedAnswer !== null}
            >
              {option}
            </button>
          );
        })}
      </div>

      {showExplanation && (
        <div className="explanation-section">
          <div className={`result-badge ${selectedAnswer === question.correctAnswer ? 'correct-badge' : 'incorrect-badge'}`}>
            {selectedAnswer === question.correctAnswer ? '正解！' : '不正解'}
          </div>
          <p className="explanation-text">{question.explanation}</p>
          <button className="next-button" onClick={handleNextQuestion}>
            {currentQuestion < questions.length - 1 ? '次の問題へ' : '結果を見る'}
          </button>
        </div>
      )}

      <div className="score-display">
        現在のスコア: {score} / {currentQuestion + (selectedAnswer !== null ? 1 : 0)}
      </div>

      <button className="home-button-quiz" onClick={onBackToHome}>
        ホームに戻る
      </button>
    </div>
  );
};

export default Quiz;
